import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SeedService } from './seed.service';
import { SeedComponent } from './seed.component';

export function seedServiceFactory() {
	return new SeedService();
}


export class SeedModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
	imports: [CommonModule],
	providers: [
		{ provide: SeedService, useFactory: seedServiceFactory }
	],
	declarations: [SeedComponent],
	exports: [SeedComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
